import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import './TextAreaInput.scss';

class TextAreaInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExampleText: false,
    };

    this.toggleExampleText = this.toggleExampleText.bind(this);
    this.handleTextSuggestions = this.handleTextSuggestions.bind(this);
  }

  handleTextSuggestions() {
    const { onAnswerChange, value, textSuggestion } = this.props;
    const newValue = value ? `${value} ${textSuggestion}` : textSuggestion;
    onAnswerChange(newValue);
  }

  toggleExampleText() {
    this.setState((prevState) => ({
      showExampleText: !prevState.showExampleText,
    }));
  }

  render() {
    const {
      placeholder, rows, value, onAnswerChange, error, textAreaPrompt,
      exampleText, className, required, textPromptClass, textSuggestion,
    } = this.props;
    const { showExampleText } = this.state;

    return (
      <div className="proposal-text-area-input body-text-2">
        <div className={`medium-weight ${textPromptClass}`}>{textAreaPrompt}</div>
        { exampleText
          && (
          <div>
            <div>
              <a
                className="modal-anchor-trigger"
                tabIndex={0}
                role="button"
                onClick={this.toggleExampleText}
                id="show-example-text"
              >
                { showExampleText ? 'View less' : 'View example' }
              </a>
            </div>

            <div>
              { showExampleText
                && (
                <div className="tool-tip">
                  { exampleText }
                </div>
                )}
            </div>
          </div>
          )}
        { textSuggestion
          && (
          <div className="body-text-2 mb-4">
            Need help completing this section?&nbsp;
            <a onClick={this.handleTextSuggestions} tabIndex={0} role="button">
              Add Text Suggestions
            </a>
          </div>
          )}
        <TextareaAutosize
          className={`mt-3 ${className} ${error && 'with-error'}`}
          placeholder={placeholder}
          rows={rows}
          value={value}
          required={required}
          onChange={(e) => onAnswerChange(e.target.value)}
        />
      </div>
    );
  }
}

TextAreaInput.propTypes = {
  placeholder: PropTypes.string.isRequired,
  rows: PropTypes.number,
  value: PropTypes.string,
  onAnswerChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  textPromptClass: PropTypes.string,
  textAreaPrompt: PropTypes.string,
  exampleText: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  textSuggestion: PropTypes.string,
};

TextAreaInput.defaultProps = {
  rows: 2,
  value: '',
  error: null,
  exampleText: null,
  textPromptClass: '',
  textAreaPrompt: 'Tell us more about that.',
  className: 'proposal-text-area',
  required: true,
  textSuggestion: null,
};

export default TextAreaInput;
